import { createRouter, createWebHistory } from 'vue-router';
import { authRoutes } from './modules/auth';
import { dashboardRoutes } from './modules/dashboard';
import { distributionRoutes } from './modules/distribution';
import { importhubRoutes } from './modules/importHub';
import { productCatalogRoutes } from './modules/product-catalog';
import { networkRoutes } from './modules/network';
import { paymentsRoutes } from './modules/payments';
import { settingsRoutes } from './modules/settings';
import { setupRouterGuards } from './guards';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    ...authRoutes,
    ...dashboardRoutes,
    ...distributionRoutes,
    ...importhubRoutes,
    ...productCatalogRoutes,
    ...networkRoutes,
    ...paymentsRoutes,
    ...settingsRoutes,
  ],
});

// Setup route guards
setupRouterGuards(router);

export default router;
